import { getZrmLeaseInfo, getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { _nextTrackEvent } from '../index';
import type { ZrmClickstreamLease, ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  WHEN_LISTING_EXPIRE_LEARN_MORE: '7333',
  TOUR_SCHEDULING_UPSELL_SET_TOUR_AVAILABILITY_CTA: '6636',
} as const;

export const WHEN_LISTING_EXPIRE_LEARN_MORE_EVENT_ID = EVENT_IDS.WHEN_LISTING_EXPIRE_LEARN_MORE;
export const TOUR_SCHEDULING_UPSELL_SET_TOUR_AVAILABILITY_CTA_EVENT_ID =
  EVENT_IDS.TOUR_SCHEDULING_UPSELL_SET_TOUR_AVAILABILITY_CTA;

// https://dataportal.zillowgroup.net/event-registry/7333
export const emitWhenListingExpireLearnMoreClickEvent = ({
  user,
  currentProperty,
  lease,
}: {
  user: ZrmClickstreamUser;
  currentProperty: ZrmClickstreamListing;
  lease?: ZrmClickstreamLease;
}) =>
  _nextTrackEvent.leaseListingUser({
    envelope: {
      event_template_id: '177',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.WHEN_LISTING_EXPIRE_LEARN_MORE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'active_listing',
      trigger_source_nm: 'learn_more_listing_expiration',
    },
    semantic: {
      semantic_event_nm: 'learn_more_listing_expiration',
      topic_tag_txt: [],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(currentProperty),
    ...getZrmLeaseInfo(lease),
  });

// https://dataportal.zillowgroup.net/event-registry/6636
export const emitTourSchedulingUpsellSetTourAvailabilityCtaEvent = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.TOUR_SCHEDULING_UPSELL_SET_TOUR_AVAILABILITY_CTA,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'tour_module',
      trigger_source_nm: 'setup_tour_availability',
    },
    semantic: {
      semantic_event_nm: 'tour_scheduling_entrypoint',
      topic_tag_txt: ['zrm_tour_scheduling', 'zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
